export const formModel = {
    email: '',
    password: ''
};

export const validateModel = { email: '', password: '' };

export const validateForgotModel = { email: '' };
